




















































































































































































































































































































































/*
    * Render the data table components and features.
*/
import Vue from 'vue';
import Axios from 'axios';
import moment from 'moment';
import VueRouter from "vue-router";
import * as _ from 'lodash';
import { Component, Prop } from "vue-property-decorator";
import CrudContext from "./../../../../ContextMenu/CRUDContext.vue";
import ExportContextComponents from "./../../../../ContextMenu/ExportContext.vue";
import TextInput from "./../Form/FieldTypes/TextInput.vue";
import TextArea from "./../Form/FieldTypes/TextArea.vue";
import Number from "./../Form/FieldTypes/Number.vue";
import ComboBox from "./../Form/FieldTypes/ComboBox.vue";
import MultiSelect from "./../Form/FieldTypes/MultiSelect.vue";
import Date from "./../Form/FieldTypes/Date.vue";
import File from "./../Form/FieldTypes/File.vue";
import VCCM from "vue-custom-context-menu";
import SwitchInput from "./../Form/FieldTypes/SwitchInput.vue";
import AccessDenied from "./../../../../AccessDenied/AccessDenied.vue";
Vue.use(VCCM);

/*
    * Component's properties and events
*/
@Component({
    components: {
        CrudContext,
        ExportContextComponents,
        TextInput,
        TextArea,
        Number,
        ComboBox,
        MultiSelect,
        Date,
        File,
        VCCM,
        SwitchInput,
        AccessDenied
    }
})

export default class ChildComponent extends Vue {   
    private editItem: any = {};
    private editedItem: any = {};
    private dialog: boolean =  false;
    private isMobile: boolean = false;
    private editedIndex: number = -1;

    /*
        * Component's props
    */
    @Prop() readonly parentName!: any;

    /*
        *  A component�s settings option must be a function, so that each instance can maintain an independent copy of the returned data object.
        *  this.$options.parent.fileName - current componets name
    */
    get settings() {
        // @ts-ignore
        let parentContext = this.$store.state[this.parentName];

        // @ts-ignore
        this.$options.parent.fileName = parentContext.child.childContext;
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName];
        context.orgFields = context.fields;
       
        //#.Check if the componet is inline editor
        if (context.inlineEditor.enabled) {
            context.tempData = [];
            context.editedIndexArray = [];
        }

        return context;
    }

    //#. The mounted() method gives you access to templates and enables interaction with the DOM.
    mounted() {
        // @ts-ignore
        let parentContext = this.$store.state[this.parentName];

        // @ts-ignore
        this.$options.parent.fileName = parentContext.child.childContext;
       
        // @ts-ignore
        this.$store.dispatch('load', this.$store.state[this.$options.parent.fileName]);
    }

    /*
        * Handling the pagination
    */
    _dtInlineRowHandling(pagination) {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName],
            defaultRowData = {};

        if (context.multiselect)
            context.indeterminate = true;

        context.pagination.page = pagination.page;

        //#.Auto create an empty row if inline editor empty row annotation is enabled
        if (context.inlineEditor.enabled && context.inlineEditor.emptyRow) {
            if (context.formData.length == 0) {
                return;
            }

            context.isDirty = false;

            if (context.emptyRowIndex != -1) {
                context.formData.splice(context.emptyRowIndex, 1);
            }

            //#.Reset all the default values in fields
            if (context.fields.length != undefined) {
                context.fields.filter(x => x.list != false && x.type != 'Hidden').forEach(key => {
                    defaultRowData[key.value] = context.defaultItem[key.value];

                    if (key.displayCurrentDate) {
                        return;
                    }

                    if (context.defaultItem[key.value] && !key.defaultValue)
                        defaultRowData[key.value] = null;
                });
            }

            context.pagination.pageSize = pagination.itemsPerPage;

            //#.Adding empty row to records based on pagination
            let emptyRowTempData = [];
            _.forOwn(context.formData, function (key, val) {
                if (context.pagination.pageSize != -1 && context.pagination.pageSize - 1) {
                    if (context.formData.length > (context.pagination.pageSize - 1)) {
                        // @ts-ignore
                        if ((context.pagination.pageSize - 1) === val) {
                            // @ts-ignore
                            emptyRowTempData.push(defaultRowData);
                        }
                        // @ts-ignore
                        emptyRowTempData.push(key);
                    }
                }
            });

            //#.Newly added records pushed to form data
            if (context.pagination.pageSize == -1 || (context.formData.length <= (context.pagination.pageSize - 1))) {
                context.formData.push(defaultRowData);
            } else {
                context.formData = emptyRowTempData;
            }

            //#.Index of empty row
            context.emptyRowIndex = context.formData.indexOf(defaultRowData);

            //#.Check if the new record index
            context.editedIndex = context.formData.indexOf(defaultRowData);
            context.editedIndexArray.push(context.editedIndex);
        }
    }

    /*
        * Custom sort function.
    */
    _dtSort(items, index, isDesc) {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName],
            defaultRowData = {};

        //# Sort if only there is minimum elements to sort
        if (index.length == 0 || (!context.inlineEditor.enabled && items.length < 2)
            || (context.inlineEditor.enabled && context.inlineEditor.emptyRow && items.length < 3)) {
            return items;
        }

        if (context.emptyRowIndex != -1) {
            items.splice(context.emptyRowIndex, 1);
        }

        //#.Sort in Ascending order
        if (isDesc.length > 0 && !isDesc[0]) {
            //#.Sorting in case of text
            if (context.fields.filter(x => x.value == index && (x.type == "TextInput" || x.type == "TextArea")).length > 0) {
                items.sort((a, b) => (a[index].toLowerCase() > b[index].toLowerCase()) ? 1 : -1);
            }

            //#.Sorting in case of number
            if (context.fields.filter(x => x.value == index && x.type == "Number").length > 0) {
                items.sort((a, b) => (a[index] > b[index]) ? 1 : -1);
            }

            //#.Sorting in case of combobox
            if (context.fields.filter(x => x.value == index && x.type == "ComboBox").length > 0) {
                context.fields.filter(x => x.type == 'ComboBox').forEach(key => {
                    context.formData.filter(x => x[key.value] != null && x[key.value] != "").forEach(record => {
                        if (typeof (record[key.value]) == "object") {
                            items.sort((a, b) => (a[index].DisplayText.toLowerCase() > b[index].DisplayText.toLowerCase()) ? 1 : -1);
                        }
                        else {
                            items.sort((a, b) => (a[index].toLowerCase() > b[index].toLowerCase()) ? 1 : -1);
                        }
                    });
                });
            }

            //#.Sorting in case of date
            if (context.fields.filter(x => x.value == index && x.type == "Date").length > 0) {
                items.sort((a, b) => {
                    // @ts-ignore
                    return new window.Date(a[index]) - new window.Date(b[index]);
                });
            }
        }

        if (isDesc.length > 0 && isDesc[0]) {
            //#.Sorting in case of text
            if (context.fields.filter(x => x.value == index && (x.type == "TextInput" || x.type == "TextArea")).length > 0) {
                items.sort((a, b) => (a[index].toLowerCase() < b[index].toLowerCase()) ? 1 : -1);
            }

            //#.Sorting in case of number
            if (context.fields.filter(x => x.value == index && x.type == "Number").length > 0) {
                items.sort((a, b) => (a[index] < b[index]) ? 1 : -1);
            }

            //#.Sorting in case of combobox
            if (context.fields.filter(x => x.value == index && x.type == "ComboBox").length > 0) {
                context.fields.filter(x => x.type == 'ComboBox').forEach(key => {
                    context.formData.filter(x => x[key.value] != null && x[key.value] != "").forEach(record => {
                        if (typeof (record[key.value]) == "object") {
                            items.sort((a, b) => (a[index].DisplayText.toLowerCase() < b[index].DisplayText.toLowerCase()) ? 1 : -1);
                        }
                        else {
                            items.sort((a, b) => (a[index].toLowerCase() < b[index].toLowerCase()) ? 1 : -1);
                        }
                    });
                });
            }

            //#.Sorting in case of date
            if (context.fields.filter(x => x.value == index && x.type == "Date").length > 0) {
                items.sort((a, b) => {
                    // @ts-ignore
                    return new window.Date(b[index]) - new window.Date(a[index]);
                });
            }
        }

        if (context.inlineEditor.enabled && context.inlineEditor.emptyRow) {
            //#.Reset all the default values in fields
            context.fields.filter(x => x.list != false && x.type != 'Hidden').forEach(key => {
                defaultRowData[key.value] = context.defaultItem[key.value];

                if (key.displayCurrentDate) {
                    return;
                }

                if (context.defaultItem[key.value] && !key.defaultValue)
                    defaultRowData[key.value] = null;
            });

            //#.Adding empty row to records based on pagination
            let emptyRowTempData = [];
            _.forOwn(items, function (key, val) {
                if (context.pagination.pageSize != -1 && context.pagination.pageSize - 1) {
                    if (items.length > (context.pagination.pageSize - 1)) {
                        // @ts-ignore
                        if ((context.pagination.pageSize - 1) == val) {
                            // @ts-ignore
                            emptyRowTempData.push(defaultRowData);
                        }
                        // @ts-ignore
                        emptyRowTempData.push(key);
                    }
                }
            });

            //#.Newly added records pused to form data
            if (context.pagination.pageSize == -1 || (items.length <= (context.pagination.pageSize - 1))) {
                items.push(defaultRowData);
                context.formData[context.emptyRowIndex] = items[context.emptyRowIndex];
            }
            else {
                items = emptyRowTempData;
                context.formData[context.emptyRowIndex] = items[context.emptyRowIndex];
            }
        }
        return items;
    }

    /*
        * Zip or unzip file download.
    */
    _dtFileDownload(file) {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName],
            field = context.fields.find(x => x.type == 'File');
        context.downloadFiles = [];

        //#. Download file list
        context.selectedItems.filter(x => x.UploadedName).forEach(key => {
            context.downloadFiles.push(key.UploadedName);
        });

        //#. Selected file name
        if (context.downloadFiles && context.downloadFiles.length == 0) {
            context.downloadFiles.push(file);
        }

        if (field.function) {
            //#.Download event raising methods
            // @ts-ignore
            this.$store.dispatch(context.fileName + '/' + field.function, { records: context.formData }).then(result => {
                context.zipCustomName = result;
            });
        }

        //#. Checking file selection.
        if (context.downloadFiles.length == 0 && context.selectedItems.length == 0) {
            context.dashboard.snackbar = true;
            context.dashboard.color = "error";
            context.dashboard.text = context.messages.noFileSelected;
        }
    }

    /*
        * Redirect to the child component
    */
    _dtRouterLink(id, params, list, path) {
        //#.Fetch dashboard context
        let context = this.$store.state.dashboard,
            root = this.$store.state.RootApp;

        //#.Remove local storage and reset extra params to null
        localStorage.setItem('extraParams', '');
        context.extraParams = null;

        //#.Reset component id
        context.componentId = id;

        //#.Update router history
        if (list) {
            history.pushState({
                id: ''
            }, '', window.location.href.split('#')[0]);

            path = path.split("#");
            path = path[0];
        }

        //#.Checking router history details
        if (root.routers.length == 0) {
            root.routers = localStorage.getItem('routers');

            if (root.routers != "")
                root.routers = JSON.parse(root.routers);

            localStorage.setItem('routers', '');
        }

        //#.Checking router history details
        if (root.routers.length > 0) {
            //#.Add latest path in router array
            root.routers.push(path);
            localStorage.setItem('routers', JSON.stringify(root.routers));
            root.routers = localStorage.getItem('routers');

            //#.Updated latest close url.
            let url = JSON.parse(root.routers);
            root.profileClosePath = url[url.length - 2];
            root.routers = JSON.parse(root.routers);
        }

        //#.Update extra params
        if (params) {
            context.extraParams = params;
            localStorage.setItem('extraParams', params);
        }
        
        this.$store.dispatch('dashboard/getTemplate', { context: context, lang: this.$vuetify.lang });
    }

    /*
        * Data table - Custom button list
    */
    _dtCustomButtons(field, item) {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName];

        //#.Data table custom button event raising methods
        this.$store.dispatch(context.fileName + '/' + field.method, { item });
    }

    /*
        * Data table - Shows edit form for a row.
    */
    _dtEdit(item, fieldName) {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName];

        //#.Add form are triggered with the store.dispatch method.
        this.$store.dispatch('dashboard/_dtEdit', { context: context, self: this, item: item, fieldName: fieldName });
    }

    /*
        * Set focus on first editable field
    */
    _dtSetFocusOnElement(field) {
        setTimeout(() => {
            this.$parent.$parent.$children[0].$children[2].$refs[field][0].$refs[field].focus();
        }, 50);
    }

    /*
        *  Data table - This method is used to delete row from server and the table.
    */
    _dtDelete(item) {
        // @ts-ignore
        var context = this.$store.state[this.$options.parent.fileName];

        if (context.permissions.indexOf('D') == -1) {
            //#.Enable notify are triggered with the store.dispatch method.
            this.$store.dispatch('dashboard/enableNotify', { color: 'info', text: context.messages.permissionWarn });
            return
        }

        //#.Enable notify are triggered with the store.dispatch method.
        // @ts-ignore
        this.$store.dispatch('dashboard/enableNotify', { color: 'confirm', text: context.messages.deleteConfirm, record: item, name: this.$options.parent.fileName, type: 'delete' });
    }

    /*
        * Trigger selection change event
    */
    _dtSelectionChanged(item, fieldName) {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName];

        //#.selectionChanged event raising methods
        this.$store.dispatch(context.fileName + '/selectionChanged', { item, fieldName });
    }

    /*
        * Trigger custom ui change event
    */
    _dtChangeColumnUI(item, fieldName) {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName];

        //#.changeColumnUI event raising methods
        this.$store.dispatch(context.fileName + '/changeColumnUI', { item, fieldName });

        //#.return color
        return context.columnUI;
    }

    /*
        * Inline editor - Will only reset changed input values and not alter their state
        * index - temporary record index
    */
    _inlCancel(item) {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName],
            index = context.tempData.indexOf(item);

        //#.Remove notify component in the DOM
        context.notify.enabled = false;

        //#.Checking inline editor empty row
        if (context.inlineEditor.emptyRow && (context.formData.indexOf(item) == (context.emptyRowIndex)) && !context.isDirty) {
            return;
        }

        //#.Add isDiry lisstener for controls in the form
        if (context.isDirty) {
            //#.Enable notify are triggered with the store.dispatch method.
            // @ts-ignore
            this.$store.dispatch('dashboard/enableNotify', { color: 'confirm', text: context.messages.changesConfirm, record: item, name: this.$options.parent.fileName });
        } else {
            //#.Remove editable record index in the editedIndexArray
            if (context.editedIndexArray.length > 0) {
                // @ts-ignore
                delete context.editedIndexArray.splice(context.editedIndexArray.indexOf(context.formData.indexOf(item)), 1);
            }

            //#.Removed newly added records in the temp data 
            if (index != -1 && !context.inlineEditor.emptyRow) {
                // @ts-ignore
                delete context.formData.splice(context.formData.indexOf(context.notify.item), 1);
                // @ts-ignore
                delete context.tempData.splice(context.tempData.indexOf(context.notify.item), 1);
                return;
            }

            //#.When user click the close button reset the edit index
            context.editedIndex = null;
            context.isDirty = false;

            //#.Reset the current operation
            context.formCreate = false;
        }
    }

    /*
        * Vuetify components look and feel change to mobile view
    */
    onResize() {
        if (window.innerWidth < 769) {
            //#.Enable mobile view
            this.$store.state.dashboard.isMobile = true;
            this.isMobile = true;
        } else {
            //#.Disable mobile view
            this.isMobile = false;
            this.$store.state.dashboard.isMobile = false;
        }
    }

    /*
        * Fetch download file informations
    */
    _download(field, index) {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName];

        if (field.function) {
            //#.Download event raising methods
            this.$store.dispatch(context.fileName + '/' + field.function, { records: context.formData, row: context.formData[index] }).then(result => {
                field.downloadName = result;
            });
        }
    }

    /*
        * Fetch mail informations
    */
    _mailto(field, index) {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName];

        if (field.mailto.subject) {
            //#.Mail to subject event raising methods
            this.$store.dispatch(context.fileName + '/' + field.mailto.subject, { records: context.formData, row: context.formData[index] }).then(result => {
                field.subject = result;
            });
        }
    }

    /*
        * Card Type: Grid - inline editor saves add/ editing form to the server and updates the record on the table.
        * id - current componet id pass to parent key fields
        * record - saving object
        * item - Displaying object (foreign key fields display text saving based on the id)
    */
    _inlSave(items) {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName],
            id = context.dashboard.componentId,
            index = context.editedIndex,
            record = {},
            self = this;

        //#.Check if the componet is add / edit form
        if (!context.parentComponent && context.dashboard.componentId == 0) {
            //#.Enable notify are triggered with the store.dispatch method.
            // @ts-ignore
            this.$store.dispatch('dashboard/enableNotify', { color: 'error', text: context.messages.cardFill });
            return;
        }

        //#.Enabled empty row
        if (context.inlineEditor.enabled && context.inlineEditor.emptyRow && context.formData.indexOf(items) == (context.emptyRowIndex)) {
            context.formCreate = true;
        } else {
            context.formCreate = false;
        }

        //#.Disable the enabled save button
        context.buttonDisabled = true;

        //#.Update form data object
        if (!context.ajaxFormSubmit) {
            items["FormData"] = context.editedItem["FormData"] || new FormData();
        }

        //#.Update state
        context.editedItem = items;

        if (context.editedIndex == -1 || context.formCreate) {
            //#.Current operation action
            let createActions = context.actions.createAction, item = {};

            //#.Pass parent key value to child components
            let parentKey = context.fields.find(x => x.parent == true);

            if (parentKey)
                context.editedItem[parentKey.value] = id;

            //#.Fetch primary key field and set value to zero
            let keyField = context.fields.filter(x => x.primaryKey == true).find(x => x).value;

            if (keyField)
                context.editedItem[keyField] = 0;

            //#.Masked false to the server and updates the record on the table.e
            context.fields.filter(x => x.mask && x.mask.enabled == true).forEach(key => {
                if (context.editedItem[key.value])
                    record[key.value] = (context.editedItem[key.value]).toString().replace(/\D+/g, '');
            });

            //#.Fetch foreign key field values with single value
            context.fields.filter(x => x.type == 'ComboBox').forEach(key => {
                if (context.editedItem[key.value] != null && typeof (context.editedItem[key.value]) == "object") {
                    record[key.value] = context.editedItem[key.value].Value;
                    item[key.value] = context.editedItem[key.value].DisplayText;
                } else if (!context.editedItem[key.value]) {
                    record[key.value] = null;
                }

                //#.Check form action be direct form submit or not
                if (!context.ajaxFormSubmit) {
                    this._dtFormSubmit(context, key, record);
                }
            });

            //#.Fetch Switch input values
            context.fields.filter(x => x.type == 'SwitchInput').forEach(key => {
                record[key.value] = context.editedItem[key.value];

                if (record[key.value] == true || record[key.value] == 1) {
                    item[key.value] = 1;
                    record[key.value] = 1;
                } else {
                    record[key.value] = 0;
                    item[key.value] = 0;
                }
            });

            //#.Fetch date value based on the settings
            context.fields.filter(x => x.type == 'Date').forEach(key => {
                if (context.editedItem[key.value]) {
                    record[key.value] = moment(context.editedItem[key.value]).format('YYYY-MM-DD');

                    //#.Check form action be direct form submit or not
                    if (!context.ajaxFormSubmit) {
                        this._dtFormSubmit(context, key, record);
                    }
                }

                //# Issue with  not nullable Date field
                if (context.editedItem[key.value] == "" && key.required) {
                    context.editedItem[key.value] = undefined;
                }
            });

            //#.Fetch currency value based on the settings
            context.fields.filter(x => x.type == 'Number' && x.currency && x.currency.enabled).forEach(key => {
                let patternWithoutDecimalSeparator = new RegExp("[^0-9-" + context.currency.decimal + "\\s]", "gi");
                record[key.value] = (context.editedItem[key.value]).replace(patternWithoutDecimalSeparator, '').replace(/\s+/g, "");

                //#.Check form action be direct form submit or not
                if (!context.ajaxFormSubmit) {
                    this._dtFormSubmit(context, key, record);
                }
            });

            //#.Added hiden/primaryKey/foreignKey fields values in new object
            // @ts-ignore
            _.forOwn(context.editedItem, function (val, key) {
                if (!record[key] && record[key] != 0) {
                    record[key] = val;

                    if (val == "") {
                        record[key] = undefined;
                    }

                    //#.Check form action be direct form submit or not
                    if (!context.ajaxFormSubmit) {
                        self._dtFormSubmit(context, key, record);
                    }
                }

                // @ts-ignore
                if (!item[key])
                    item[key] = val;
            });

            //#.Create action are triggered with the store.dispatch method.
            this.$store.dispatch('Create', { item, record, keyField, createActions, context, self });

            return;
        }

        if (context.editedIndex > -1) {
            //#.Current operation action
            let updateActions = context.actions.updateAction,
                item = context.editedItem;

            //#.Fetch foreign key field values with single value
            context.fields.filter(x => x.type == 'ComboBox').forEach(key => {
                if (context.editedItem[key.value] != null && typeof (context.editedItem[key.value]) == "object") {
                    record[key.value] = context.editedItem[key.value].Value;
                    item[key.value] = context.editedItem[key.value].DisplayText;
                } else if (!context.editedItem[key.value]) {
                    record[key.value] = null;
                } else if (key.select && context.editedItem[key.value] == key.select.DisplayText) {
                    record[key.value] = key.select.Value;
                } else {
                    record[key.value] = key.dropdown.find(x => x.DisplayText == context.editedItem[key.value]).Value;
                }

                //#.Check form action be direct form submit or not
                if (!context.ajaxFormSubmit) {
                    this._dtFormSubmit(context, key, record);
                }
            });

            //#.Fetch Switch input values
            context.fields.filter(x => x.type == 'SwitchInput').forEach(key => {
                record[key.value] = context.editedItem[key.value];

                if (record[key.value] == true || record[key.value] == 1) {
                    item[key.value] = 1;
                    record[key.value] = 1;
                } else {
                    record[key.value] = 0;
                    item[key.value] = 0;
                }
            });

            //#.Fetch date value based on the settings
            context.fields.filter(x => x.type == 'Date').forEach(key => {
                if (context.editedItem[key.value]) {
                    record[key.value] = moment(context.editedItem[key.value]).format('YYYY-MM-DD');

                    //#.Check form action be direct form submit or not
                    if (!context.ajaxFormSubmit) {
                        this._dtFormSubmit(context, key, record);
                    }
                }

                //# Issue with  not nullable Date field
                if (context.editedItem[key.value] == "" && key.required) {
                    context.editedItem[key.value] = undefined;
                }
            });

            //#.Fetch currency value based on the settings
            context.fields.filter(x => x.type == 'Number' && x.currency && x.currency.enabled).forEach(key => {
                let patternWithoutDecimalSeparator = new RegExp("[^0-9-" + context.currency.decimal + "\\s]", "gi");
                record[key.value] = (context.editedItem[key.value]).replace(patternWithoutDecimalSeparator, '').replace(/\s+/g, "");

                //#.Check form action be direct form submit or not
                if (!context.ajaxFormSubmit) {
                    this._dtFormSubmit(context, key, record);
                }
            });

            //#.Masked false to the server and updates the record on the table.e
            context.fields.filter(x => x.mask && x.mask.enabled == true).forEach(key => {
                if (context.editedItem[key.value])
                    record[key.value] = (context.editedItem[key.value]).toString().replace(/\D+/g, '');
            });

            //#.Added hiden/primaryKey/foreignKey fields values in new object
            // @ts-ignore
            _.forOwn(context.editedItem, function (val, key) {
                if (!record[key] && record[key] != 0) {
                    record[key] = val;

                    if (val == "") {
                        record[key] = undefined;
                    }

                    //#.Check form action be direct form submit or not
                    if (!context.ajaxFormSubmit) {
                        self._dtFormSubmit(context, key, record);
                    }
                }

                // @ts-ignore
                if (!item[key])
                    item[key] = val;
            });

            //#.Update action are triggered with the store.dispatch method.
            this.$store.dispatch('Update', { record, item, index, updateActions, context, self });
        }
    }

    /*
        * Override the create new record submit method
        * Direct form submit for file upload added   
    */
    _dtFormSubmit(context, key, record) {
        if (!context.editedItem["FormData"])
            context.editedItem["FormData"] = new FormData();

        if (record[key.value])
            context.editedItem["FormData"].append(key.value, record[key.value]);
        else if (record[key])
            context.editedItem["FormData"].append(key, record[key]);
    }

    /*
        * Update summary panel with values
    */
    getSummary(field, fieldName) {
        if (fieldName && field.summaryPanel) {
            // @ts-ignore
            let context = this.$store.state[this.$options.parent.fileName];

            //#.Calculate sum for summary panel
            if (field.summaryPanel.formula == context.formulaTypes.sum) {
                field.summaryPanel.result = _.sumBy(context.formData, function (record) {
                    // @ts-ignore
                    record[fieldName] = (record[fieldName] == "" ? 0 : record[fieldName]);
                    // @ts-ignore
                    record[fieldName] = parseFloat(record[fieldName]);
                    // @ts-ignore
                    return record[fieldName];
                });
                return field.summaryPanel.result;
            }

            //#.Calculate min for summary panel
            if (field.summaryPanel.formula == context.formulaTypes.min) {
                // @ts-ignore
                field.summaryPanel.result = _.minBy(context.formData, function (record) {
                    // @ts-ignore
                    record[fieldName] = (record[fieldName] == "" ? 0 : record[fieldName]);
                    // @ts-ignore
                    record[fieldName] = parseFloat(record[fieldName]);
                    // @ts-ignore
                    return record[fieldName];
                })[fieldName];
                return field.summaryPanel.result;

            } else if (field.summaryPanel.formula == context.formulaTypes.max) {

                //#.Calculate max for summary panel
                // @ts-ignore
                field.summaryPanel.result = _.maxBy(context.formData, function (record) {
                    // @ts-ignore
                    record[fieldName] = (record[fieldName] == "" ? 0 : record[fieldName]);
                    // @ts-ignore
                    record[fieldName] = parseFloat(record[fieldName]);
                    // @ts-ignore
                    return record[fieldName];
                })[fieldName];
                return field.summaryPanel.result;

            } else if (field.summaryPanel.formula == context.formulaTypes.average) {

                //#.Calculate average for summary panel
                field.summaryPanel.result = _.meanBy(context.formData, function (record) {
                    // @ts-ignore
                    record[fieldName] = (record[fieldName] == "" ? 0 : record[fieldName]);
                    // @ts-ignore
                    record[fieldName] = parseFloat(record[fieldName]);
                    // @ts-ignore
                    return record[fieldName];
                });

                field.summaryPanel.result = (field.summaryPanel.result).toFixed(2);
                return field.summaryPanel.result;

            } else if (field.summaryPanel.formula == context.formulaTypes.count) {

                //#.Calculate count for summary panel
                field.summaryPanel.result = context.formData.length;
                return field.summaryPanel.result;

            } else {

                //#.Calculate custom for summary panel
                let action = fieldName.charAt(0).toLowerCase() + fieldName.slice(1);

                //#.Summary event raising methods
                this.$store.dispatch(context.fileName + '/' + field.summaryPanel.formula, { data: context.formData, record: field });
            }
        }
    }

    /*
        * Row selection event
    */
    _dtRowSelection(item) {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName];
       
        //#.Checking inline editor
        if (context.inlineEditor.enabled && context.inlineEditor.emptyRow) {
            let index = context.formData.indexOf(item);
            context.contextMenuIndex = context.formData.length - index == 1 ? -1 : index;
        }

        //#.Row selection action are triggered with the store.dispatch method.
        this.$store.dispatch('dashboard/rowSelection', { item, context }, { root: true });
    }

    /*
        * Checkbox selection change event
    */
    _chkSelection(item) {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName];

        //#.If check or uncheck.
        if (!context.selected.includes(item)) {
            context.selected.push(item);
        } else {
            let index = context.selected.indexOf(item);
            context.selected.splice(index, 1);
            context.indeterminate = true;
        }
    }

    /*
        * _dtChk selection change event
    */
    _dtChkSelection(record) {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName],
            count = 0;

        //#.Reset checkbox intermidiate
        _.forOwn(record.items, function (key, val) {
            if (context.selected.includes(key)) {
                count++;
            }
        });
        if (count == 0) {
            record.value = true;
        }
        else {
            record.value = false;
        } 

        if (record.value) {
            _.forOwn(record.items, function (key, val) {
                context.selected.push(key);
            });
            context.selectedItems = context.selected;
            context.indeterminate = false;
        } else {
            _.forOwn(record.items, function (key, val) {
                let item = key;

                if (context.selected.length > 0) {
                    let index = context.selected.indexOf(item);
                    
                    if (index != -1) {
                        context.selected.splice(index, 1);
                    }
                }
            });
            context.selectedItems = context.selected;
        }
    }

    /*
        * The show-select prop will render a checkbox in the default header to toggle all rows
    */
    _dtToggleSelectAll(e) {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName];

        //#. Checkbox selected item collection.
        context.selectedItems = context.selected;
    }

    /*
        * Data table group settings
    */
    _dtGroupBySettings(fieldName) {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName];
        context.grouping.defaultGroupBy = fieldName;

        if (context.grouping.defaultGroupBy)
            context.grouping.title = context.fields.find(x => x.value == fieldName).title;

        return fieldName;
    }

    /*
        * Remove group settings
    */
    _dtRemoveGroupBySettings(fieldName) {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName];
        context.grouping.defaultGroupBy = [];
        context.grouping.title = '';
        context.grouping.collapse = false;

        //#. Delete grouping
        if (context.formData.length > 0) {
            context.formData.filter(x => x.hide == true || x.hide == false).forEach(key => {
                delete key.hide;
            });
        }

        context.renderTable = false;
        this.$nextTick(() => {
            //#. Add the component back in
            context.renderTable = true;
        });
    }

    /*
        * Data table grouping option
    */
    _dtGrouping(category, name) {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName],
            item = category[context.grouping.defaultGroupBy];

        context.grouping.defaultGroupBy = name;
        context.renderTable = false;

        //#. Define grouping
        context.formData.forEach(dessert => {
            if (dessert[context.grouping.defaultGroupBy] === item) {
                dessert.hide = !dessert.hide;
            }
        });

        this.$nextTick(() => {
            //#. Add the component back in
            context.renderTable = true;
        });
    }

    /*
        * Check if the context option is enabled or disabled
    */
    get appropriateContextMenu() {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName];

        if (context.contextMenu)
            return "cm-for-list-item";
        else
            return null;
    } 
}
